module.exports = __webpack_public_path__ + "img/Paladin-bloodelf-m-70.e44b0a01.gif";